import { useEffect, useMemo, useState } from 'react'
import { Task } from '../../../../types'
import { useStorePlayer } from '../store'
import { useChordsData } from './use-chords-data'
import { config } from '../../../../config'
import { useAddBeatschords } from '../../../../lib/operations/creation'

interface UseDataProps {
  task: Task
}

const STATUS_MAP = {
  QUEUED: 'loading',
  STARTED: 'loading',
  COMPLETED: 'succeeded',
  FAILED: 'failed'
} as const

export const useDataMetadata = ({ task }: UseDataProps): void => {
  const { setData } = useStorePlayer()

  const { beatschords } = task?.summary?.v1

  const onAddBeatschords = useAddBeatschords(task?.id, {} as any)

  const [addOperation, setAddOperation] = useState(false)
  useEffect(() => {
    if (!task?.isOwner || addOperation) return

    if (!beatschords) {
      setAddOperation(true)
      onAddBeatschords()
    }
  }, [task?.isOwner, beatschords, addOperation, onAddBeatschords])

  useChordsData({
    beatschords
  })

  const beatMapUrl = useMemo(() => {
    const beatsFile = beatschords?.beats?.beatsFile?.path
    return beatsFile
      ? `${config.api.endpoint}/v3/download${beatsFile}`
      : undefined
  }, [beatschords])

  useEffect(() => {
    const status =
      (beatschords && beatschords?.status && STATUS_MAP[beatschords?.status]) ||
      (beatschords?.beats && 'succeeded') ||
      'loading'

    setData({
      beatMapUrl,
      metadata: {
        status,
        key: beatschords?.key,
        tuning: Number(beatschords?.tuning),
        bpm: beatschords?.beats?.bpm
      }
    })
  }, [task, beatMapUrl, beatschords, setData])
}
